import initCapitalize from "./initCapitalize";

export const capitalizeField = (field: string): string => {
	const formattedString = field.replace(/_/g, " ");
	return initCapitalize(formattedString);
};
